import React from "react";
import { useTranslation } from "react-i18next";

export default function DeleteConfirmModal({
  open,
  title,
  message,
  error,
  loading,
  onCancel,
  onConfirm,
  confirmText,
  cancelText
}) {
  const { t } = useTranslation();

  if (!open) return null;
  return (
    <div style={modalOverlay}>
      <div style={modalContent}>
        <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 12 }}>
          {title || t("DeleteConfirmModal.confirm_delete", "Delete")}
        </div>
        <div style={{ color: "#444", marginBottom: 18 }}>
          {message || t("DeleteConfirmModal.delete_confirm_message", "Are you sure you want to delete this item?")}
        </div>
        {error && (
          <div style={{ color: "red", marginBottom: 12 }}>{error}</div>
        )}
        <div style={{ display: "flex", gap: 16, justifyContent: "flex-end" }}>
          <button
            onClick={onCancel}
            style={{
              background: "#0b74de",
              color: "#fff",
              border: "none",
              borderRadius: 0,
              padding: "8px 24px",
              fontWeight: 600,
              fontSize: 15,
              cursor: loading ? "not-allowed" : "pointer"
            }}
            disabled={loading}
          >
            {cancelText || t("DeleteConfirmModal.cancel", "Cancel")}
          </button>
          <button
            onClick={onConfirm}
            style={{
              background: "#232b35",
              color: "#fff",
              border: "none",
              borderRadius: 0,
              padding: "8px 24px",
              fontWeight: 600,
              fontSize: 15,
              cursor: loading ? "wait" : "pointer"
            }}
            disabled={loading}
          >
            {loading ? t("DeleteConfirmModal.deleting", "Deleting...") : (confirmText || t("DeleteConfirmModal.delete", "Delete"))}
          </button>
        </div>
      </div>
    </div>
  );
}

const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000
};

const modalContent = {
  background: "#fff",
  borderRadius: 0,
  padding: 24,
  boxShadow: "0 2px 16px rgba(44,62,80,0.18)",
  minWidth: 320,
  maxWidth: "90vw"
};